import { Component, Inject, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormulaList } from '../kpi-models/FormulaList';
import { GlobalService } from './../../services/global.service';
import { AlertComponent } from '../../common/alert/alert.component';
import { ConfirmModelComponent } from '../../common/confirm-model/confirm-model.component';
import { Globals } from 'src/app/models/globals.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CreateFormulaModelComponent } from '../create-formula-model/create-formula-model.component';
import { EvaluateFormulaModelComponent } from '../evaluate-formula-model/evaluate-formula-model.component';
import { HttpService } from 'src/app/services/http.service';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FilterModel } from '../../models/filter/filter-request.model';
import { FilterResponseModel } from '../../models/filter/filter-response.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { FilterFieldTypes } from '../../shared/common-constants';
import { evaluateFormula } from '../kpi-models/evaluateFormula';
import { KPIFormulaBuilderService } from 'src/app/services/kpi-formula-builder.service';

@Component({
  selector: 'app-viewFormula',
  templateUrl: './viewFormula.component.html',
  styleUrls: ['./viewFormula.component.css']
})
export class ViewFormulaComponent implements OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public destroyed = new Subject<any>();
  formulaList: MatTableDataSource<FormulaList>;
  isLoader = false;
  emptyData = false;
  delKpiDetails: any;
  apiUri: string;
  graphUri: string;
  headers = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  displayedColumns = ['formulaId', 'userExpression', 'targetUom', 'lastModifiedBy', 'actions'];

  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: FormulaList[];
  @ViewChild('popOver') public popover: NgbPopover;

  constructor(
    private readonly httpClient: HttpClient, 
    public dialog: MatDialog, 
    public globals: GlobalService,
    public global: Globals, 
    private readonly httpService: HttpService,
    private readonly kpiFormulaService: KPIFormulaBuilderService,
    private readonly titleService: Title,
    private readonly router: Router) {
    const emptyList: any[] = [];
    this.formulaList = new MatTableDataSource(emptyList);
    titleService.setTitle('Formula Builder');
    this.apiUri = this.global.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.global.config.graphApi_client_resourceUri;
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      this.getToken()
    });
  }
  getToken() {
    this.kpiFormulaService.getTokendata().subscribe(locData => {
      {
        this.GetFormulaList();
      }
    });
  }


  /**
   * gets called on click of edit button.
   * opens edit dialog and takes result from it and
   * opens alert box on required cases.
   * @param rowData row to be edited
   * @param actionType type of action
   */
  openDialog(rowData, actionType) {
    this.isLoader = true;
    const dataTbSent: any = {};
    this.kpiFormulaService.getFormulaOnKpiId(rowData.formulaId).subscribe((data: FormulaList[]) => {
      dataTbSent.FormulaList = data;
      dataTbSent.UsedFor = actionType;
      const dialogRef = this.dialog.open(CreateFormulaModelComponent, {
        data: dataTbSent, panelClass: 'custom-modalbox'
      });
      
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'Success') {
          this.globals.showAlert(AlertComponent, { success: true, message: 'Updated Successfully' });
          this.GetFormulaList();
        } else if (result !== 'Cancel') {
          this.globals.showAlert(AlertComponent, { success: false, message: result.m_StringValue });
        }
      });
      this.isLoader = false;
    }, (error) => {
      this.isLoader = false;
      console.log(error);
    });
  }

  testFormula(rowData) {
    this.isLoader = true;
    const dataTbSent: any = {};
    this.kpiFormulaService.getFormulaDetailsOnKpiId(rowData.formulaId).subscribe((data: evaluateFormula[]) => {
        dataTbSent.FormulaDetails = data;
        const dataToPass = {
          title: 'Evaluate Formula',
          formulaName: rowData.formulaName,
          formulaFrequency: rowData.frequency,
          formulaExpression: rowData.userExpression,
          ignoreSi: dataTbSent.FormulaDetails[0].ignoreSi,
          data: dataTbSent
        };
       this.dialog.open(EvaluateFormulaModelComponent, {
          width: '1300px',
          disableClose: true,
          panelClass: 'confirm-modalbox',
          data: dataToPass
        });
        this.isLoader = false;
      }, (error) => {
        this.isLoader = false;
        console.log(error);
      });
  }

  /**
   * Calls backend api for getting list of formulae
   * set data to mat table datasource
   * calls further method used as primary authorization
   */
  GetFormulaList() {
    this.isLoader = true;
    this.emptyData = false;
    this.kpiFormulaService.getFormulaNames().subscribe((data: any): void => {
      if (data.length > 0) {
        this.isLoader = false;
        this.masterData = [...data];
        this.formulaList = new MatTableDataSource(data);
        this.formulaList.paginator = this.paginator;
        this.formulaList.sort = this.sort;
        this.setDisabledForUnAuthorizedUser();
        if (this.filterList.length == 0) {
          this.createFilterList();
        }
        this.isLoader = false;
      } else {
        this.emptyData = true;
        this.isLoader = false;
        this.formulaList = new MatTableDataSource(data);
      }
    }, (error) => {
      this.isLoader = false;
    });
  }

  /**
   * set disbaled property for each formula.
   * works as a primary authorization.
   */
  setDisabledForUnAuthorizedUser() {
    for (let i = 0; i < this.formulaList.filteredData.length; i++) {
      if (this.formulaList.filteredData[i].createdBy !== this.globals.loggedInUser && this.globals.globals.rbacName !== 'Platform Admin') {
        this.formulaList.filteredData[i].isDisabled = true;
      }
    }
  }

  // function to delete the entry
  deleteFormula(row) {
    this.delKpiDetails = row;
    const dataToPass = {
      title: 'Delete',
      isDelete: true,
      message: 'Are you sure to delete : ' + row.formulaId + ' ? Intermediate formulae dependent on this will also be deleted.'
    };
    this.globals.openModelWindow(this.deleteFormulaOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
  }

  /**
   * Calls post method for deletion of a formula and
   * opens popup according to result.
   * @param thisRef references current component
   */
  deleteFormulaOnConfirm(thisRef: ViewFormulaComponent) {
    thisRef.isLoader = true;
    thisRef.kpiFormulaService.getDeleteFormula(thisRef.delKpiDetails).subscribe((result: any): void => {
      if (result === 'Successfully deleted') {
        thisRef.globals.showAlert(AlertComponent, { success: true, message: result });
      } else {
        thisRef.globals.showAlert(AlertComponent, { success: false, message: result.m_StringValue });
      }
      thisRef.GetFormulaList();
      thisRef.isLoader = true;
    });
  }

  /**Creates data for filter list */
  createFilterList() {
    let cols: string[] = ['formulaId', 'userExpression', 'targetUom', 'lastModifiedBy'];
    for (let a = 0; a < cols.length; a++) {
      let tempFilter: FilterModel = new FilterModel();
      tempFilter.fieldName = this.globals.replaceDisplayText(cols[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      let unique;
      if (cols[a] == "formulaId") {
        unique = [...new Set(this.formulaList.data.map(a => a.formulaId))];
      } else if (cols[a] == "userExpression") {
        unique = [...new Set(this.formulaList.data.map(a => a.userExpression))];
      } else if (cols[a] == "targetUom") {
        unique = [...new Set(this.formulaList.data.map(a => a.targetUom))];
      } else if (cols[a] == "lastModifiedBy") {
        unique = [...new Set(this.formulaList.data.map(a => a.lastModifiedBy))];
      }
      tempFilter.values = unique.sort((n1, n2) => n1 - n2);
      this.filterList.push(tempFilter);
    }
  }

  /**
   * Returns data from child filter component
   * @param event
   */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.formulaList.data = this.globals.conditionalDataFiltering(filterResponse, this.formulaList.data);
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
  * Removes that filter
  * @param selectedFilter
  */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.formulaList.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.formulaList.data = this.globals.conditionalDataFiltering(element, this.formulaList.data);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }
}


@Component({
  selector: 'app-editBox',
  templateUrl: './editBox.component.html',
  styleUrls: ['./viewFormula.component.css']
})
export class EditBoxComponent {
  [x: string]: any;
  isLoader = false;

  constructor(
    public dialogRef: MatDialogRef<EditBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormulaList, private readonly httpClient: HttpClient, public globals: GlobalService,
    public global: Globals, private readonly kpiFormulaService: KPIFormulaBuilderService) {
    this.apiUri = this.global.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.global.config.graphApi_client_resourceUri;
  }

  /**
   * calls update post call and returns result
   * @param data data of formula to be edited
   */
  public OnUpdateClick(data): void {
    this.isLoader = true;
    this.data.lastModifiedBy = this.globals.loggedInUser;
    this.kpiFormulaService.getEditFormula(data).subscribe((result: any): void => {
      this.isLoader = false;
      this.dialogRef.close(result);
    });
  }

  /**
   * get call on click of cancle button on update dialog box
   * closes dialog box with result as 'Cancel'
   */
  onCancelClick(): void {
    this.dialogRef.close('Cancel');
  }
}
